import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "15",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m3 12 9-9",
      class: "st0",
      style: {"fill":"none","stroke":"#888","stroke-width":"1.5","stroke-miterlimit":"10"}
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.5",
      cy: "7.5",
      r: "6.7",
      class: "st0",
      style: {"fill":"none","stroke":"#888","stroke-width":"1.5","stroke-miterlimit":"10"}
    }, null, -1)
  ]))]))
}
export default { render: render }